import { IFormUI } from "./FormUI/FormUI";
import { IForm } from "./XGControls/IForm";
/**
     * Účel otvíraného formuláře
     * @includeToDoc
     */
export enum FormPurpose {
    standard,
    lov,
}

/**
 * Rozhraní tovární metody, kterou je možné použít pro vytváření FormUI
 * @includeToDoc
 */
export interface IFormUIFactory {
    /**
     * Tovární metodě je předán formulář, pro které se má vytvořit FormUI a jeho účel, který je možné zohlednit
     * @param form Formulář, pro které se má vytvořit FormUI
     * @param formPurpose Účel otvíraného formuláře
     * @returns Nové FormUI
     */
    (form: IForm, formPurpose: FormPurpose | string): IFormUI;
}
